import { FC } from 'react'

import { IIconProps } from '../IIconProps'

export const NotStartedIcon: FC<IIconProps> = ({ width = 24, height = 24, viewBox }) => {
  const radius = 120
  const strokeWidth = radius * 0.1
  const center = 128

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox || '0 0 256 256'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx={center}
        cy={center}
        r={radius}
        stroke="#004A84"
        strokeWidth={strokeWidth}
        fill="none"
      />
    </svg>
  )
}
